module.exports = __webpack_public_path__ + "static/media/hero-three.67fef06e.png";